let unsubscribedBlock = `
<table style="box-sizing: border-box; height: 150px; margin: 0 auto 10px auto; padding: 5px 5px 5px 5px; width: 100%;" width="100%" height="150">
	<tbody style="box-sizing: border-box;">
		<tr style="box-sizing: border-box;">
			<td style="box-sizing: border-box; font-size: 12px; font-weight: 300; vertical-align: middle; color: rgb(111, 119, 125); margin: 0; padding: 0; text-align: center;" valign="middle" align="center">
				<h1 class="heading" style="box-sizing: border-box; color: #000000;"></h1>
				<p class="email-footer" style="box-sizing: border-box; text-align: center; font-style: normal; font-family: Arial, Helvetica, sans-serif; line-height: 16px; color: #6f777d;">
					<i style="box-sizing: border-box;">Copyright © {{ANNO_CORRENTE}}, Tutti i diritti sono riservati.</i>
					<div draggable="true" data-highlightable="1" style="box-sizing: border-box;">
						<br draggable="true" data-highlightable="1" style="box-sizing: border-box;">
					</div>
					<div draggable="true" data-highlightable="1" style="box-sizing: border-box;">
						<b draggable="true" data-highlightable="1" style="box-sizing: border-box;">Il tuo indirizzo mail è: </b>
					</div>
					<div draggable="true" data-highlightable="1" style="box-sizing: border-box;">{{AZIENDA_EMAIL_PRIMARIA}}
						<br draggable="true" data-highlightable="1" style="box-sizing: border-box;">
					</div>
					<div draggable="true" data-highlightable="1" style="box-sizing: border-box;">
						<br draggable="true" data-highlightable="1" style="box-sizing: border-box;">
					</div>
					<div draggable="true" data-highlightable="1" style="box-sizing: border-box;">Non vuoi più ricevere queste mail?</div>
					<div draggable="true" data-highlightable="1" style="box-sizing: border-box;">
						<br draggable="true" data-highlightable="1" style="box-sizing: border-box;">
					</div>
					<div draggable="true" data-highlightable="1" style="box-sizing: border-box;">Clicca qui per 
						<a draggable="true" data-highlightable="1" href="{{UNSUBSCRIBED}}" target="_blank" class="link" style="box-sizing: border-box; color: #000000;">disiscriverti</a>
					</div>
					<div draggable="true" data-highlightable="1" style="box-sizing: border-box;">
						<br draggable="true" data-highlightable="1" style="box-sizing: border-box;">
					</div>
					<p draggable="true" data-highlightable="1" data-tracking-notice="1" style="box-sizing: border-box; margin: 0 0 16px 0;">Le nostre email possono contenere un pixel di tracciamento: puoi
						<a draggable="true" data-highlightable="1" href="{{TRACKING_PREFERENCES}}" target="_blank" class="link" style="box-sizing: border-box; color: #000000;">disattivarlo</a> quando vuoi.
					</p>
					<div draggable="true" data-highlightable="1" style="box-sizing: border-box;">
						<i draggable="true" data-highlightable="1" style="box-sizing: border-box;">made with</i>
						<b draggable="true" data-highlightable="1" style="box-sizing: border-box;">
							<a draggable="true" data-highlightable="1" href="https://stiip.it/" target="_blank" class="yello-link" style="box-sizing: border-box; color: #f9c10a;">GiveMeHive ♥</a>
						</b>
					</div>
					<div draggable="true" data-highlightable="1" style="box-sizing: border-box;">
						<br draggable="true" data-highlightable="1" style="box-sizing: border-box;">
					</div>
				</p>
			</td>
		</tr>
	</tbody>
</table>`


export {unsubscribedBlock}
